module.exports = __webpack_public_path__ + "img/web.910296c8.svg";